// @flow
import { useEffect, useRef, useState } from 'react';

export default function useLoadingDialog() {
    const [isOpen, setIsOpen] = useState(false);
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef(null);

    const clearProgressInterval = () => {
        if (intervalRef.current != null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    useEffect(() => () => clearProgressInterval(), []);

    const stopProgress = () => {
        clearProgressInterval();
        setIsOpen(false);
        setProgress(0);
    };

    const startProgress = () => {
        clearProgressInterval();
        setProgress(0);
        setIsOpen(true);
        intervalRef.current = setInterval(() => {
            setProgress(oldProgress => {
                if (oldProgress === 100) {
                    return 100;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, 500);
    };

    return {
        isOpen,
        setIsOpen,
        progress,
        setProgress,
        startProgress,
        stopProgress
    };
}
